import { useContext } from "react";

import { cn } from "src/lib/utils";
import { LanguageContext } from "./languageContext";
import "../styles/fonts/fonts.css";
import t from "src/lib/translations.json";

export function TypographyH1({
  textId,
  className,
}: {
  textId: keyof typeof t;
  className?: string;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <h1
      className={cn(
        "scroll-m-20",
        "font-graphein",
        "text-3xl",
        "font-bold",
        className
      )}
    >
      {translate(textId)}
    </h1>
  );
}

export function TypographyH2({
  id,
  textId,
  className,
}: {
  id: string;
  textId: keyof typeof t;
  className?: string;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <h2
      className={cn(
        "scroll-m-20 font-graphein pb-2 text-3xl font-semibold tracking-tight first:mt-0 text-primary",
        className
      )}
      id={id}
    >
      {translate(textId)}
    </h2>
  );
}

export function TypographyH3({
  textId,
  className,
}: {
  textId: keyof typeof t;
  className?: string;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <h3
      className={cn(
        "font-graphein scroll-m-20 text-2xl font-semibold tracking-tight text-primary",
        className
      )}
    >
      {translate(textId)}
    </h3>
  );
}

export function TypographyP({
  textId,
  className,
}: {
  textId: keyof typeof t;
  className?: string;
}) {
  const { translate } = useContext(LanguageContext);
  return (
    <p
      className={cn(
        "font-graphein leading-7 [&:not(:first-child)]:mt-6",
        className
      )}
    >
      {translate(textId)}
    </p>
  );
}
